var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStackoverflow = function SvgStackoverflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M392 440V320h40v160H64V320h40v120Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m149.1 308.77 198.57 40.87 8.4-39.32-198.57-40.87Zm26.27-93.12L359.22 300 376 263.76l-183.82-84.84Zm50.95-89 156 127.78 25.74-30.52-156-127.78ZM328 32l-33.39 23.8 120.82 160.37L448 192ZM144 400h204v-40H144Z"
  })));
};
export default SvgStackoverflow;